'use client';

import { cn } from '~/lib/utils';

type DrawerShellProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export default function DrawerShell({ children, className, onClick }: DrawerShellProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'bg-background relative flex h-full min-h-0 flex-col overflow-hidden rounded-[var(--panel-radius)]',
        className,
      )}
    >
      {children}
    </div>
  );
}
